// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStatusQuestionMarkCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16zm10 8c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zm-6-2c0 1.283-.79 1.973-1.56 2.646-.61.534-1.21 1.057-1.387 1.857-.06.27-.277.497-.553.497h-1c-.276 0-.504-.226-.474-.5.156-1.46.997-2.105 1.744-2.678.65-.498 1.23-.943 1.23-1.822 0-1.1-.9-2-2-2-.93 0-1.716.642-1.938 1.505-.068.268-.286.495-.562.495h-1c-.276 0-.503-.225-.47-.499A4 4 0 0 1 12 6c2.21 0 4 1.79 4 4zm-5 6.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgStatusQuestionMarkCircle;
